// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/chunks/main-67eed3b38205746e.js";
	if (chunkId === 636) return "static/chunks/pages/_app-c917b90f1f54f00c.js";
	if (chunkId === 593) return "static/chunks/framework-5f4737157d6b573d.js";
	if (chunkId === 829) return "static/chunks/829-754bd96f23187e74.js";
	if (chunkId === 196) return "static/chunks/196-4bd9fe6e9b5b9ae9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"86":"751680bdf0a51eaf","235":"82612a29a88ff5da","413":"7e44902994d1daac","483":"528ba42402a40ca0","532":"54425c48de0a5ed2","551":"d6b9eecb64b8f05b","613":"a461b28333ce2650","668":"9f65953a9e3a3004","861":"79603608b6919705","871":"bc49b2d01173ac59"}[chunkId] + ".js";
};